var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 71,
    viewBox: "0 0 83 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1956 17.112L44.8534 1.27139C43.8096 0.763874 42.6625 0.5 41.5 0.5C40.3375 0.5 39.1904 0.763874 38.1467 1.27139L5.80445 17.112C4.06293 17.9496 2.59471 19.2567 1.5681 20.8835C0.541495 22.5102 -0.00196931 24.3908 5.36212e-06 26.3097V60.2151C5.36212e-06 65.8865 4.70951 70.5 10.4991 70.5H72.5009C78.2905 70.5 83 65.8865 83 60.2151V26.3097C83.002 24.3908 82.4585 22.5102 81.4319 20.8835C80.4053 19.2567 78.9371 17.9496 77.1956 17.112ZM40.8293 6.52773C41.0381 6.42623 41.2675 6.37345 41.5 6.37345C41.7325 6.37345 41.9619 6.42623 42.1707 6.52773L73.5513 21.8927L41.6853 37.5037C41.4765 37.6052 41.2471 37.658 41.0146 37.658C40.7821 37.658 40.5527 37.6052 40.3439 37.5037L8.95771 22.1369L40.8293 6.52773Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8fd7424d2449bc2eb4d86b4ff1934dee.svg";
export { ForwardRef as ReactComponent };